import ActiveController from "rapid/controller";

export class startScreenAreaController extends ActiveController {
    constructor($injector, $rootScope, $scope, $upload) {
        "ngInject";
        super($injector);

        this.$rootScope = $rootScope;
        this.$upload = $upload;
        this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));
        this.validation = {
            width: {
                min: 0,
                max: 100
            },
            height: {
                min: 0,
                max: 100
            } ,
            x: {
                min: 0,
                max: 100
            },
            y: {
                min: 0,
                max: 100
            }
        };

        $scope.$watch(() => this.pixelWidth, () => {
            this.setValidation();
        });

        $scope.$watch(() => this.pixelHeight, () => {
            this.setValidation();
        });

        $scope.$watch(() => this.model ? this.model.width : null, () => {
            this.setValidation();
        });

        $scope.$watch(() => this.model ? this.model.height : null, () => {
            this.setValidation();
        });

        // Width and height limits depend on the position, which can change outside the inputs (dragging)
        $scope.$watchGroup([() => this.model ? this.model.x : null, () => this.model ? this.model.y : null], () => {
            this.setValidation();
        });

        $scope.$watch(() => this.aspectRatio, () => {
            if (this.model && this.aspectRatio) {
                this.changeSize("height");
                this.setValidation();
            }
        });
    }

    $onInit() {
        this.setValidation();
    }
    /*
    If animated icons activated width should be changed
    alongside with height
     */
    changeSize(value) {

        if (this.aspectRatio) {
            // Invalid input leaves undefined in the model: keep the other value as it is
            if (!Number.isFinite(this.model[value])) {
                return;
            }
            // px ratio = width / height; with screenWidthUnits the width is % of the layout width, not height
            const ratio = this.screenWidthUnits ? this.aspectRatio * this.pixelHeight / this.pixelWidth : this.aspectRatio;
            if (value === "width") {
                this.model.height = this.roundHalf(this.model.width / ratio);
            } else {
                this.model.width = this.roundHalf(this.model.height * ratio);
            }
            return;
        }

        if (!this.relativeSize) {
            return;
        }

        if (value === "width") {
            if (this.model.width > this.validation.height.max) {
                this.model.width = this.model.height;
            } else  {
                this.model.height = this.model.width;
            }
        } else {
            if (this.model.height > this.validation.width.max) {
                this.model.height = this.model.width;
            } else {
                this.model.width = this.model.height;
            }
        }

    }

    /**
     * Currently area width set in % of layout height.
     * For correct validation this should be change to % of width
     * @param val
     */

    getWidthInPercents(val) {
        if (!this.model) {
            return val;
        }
        let pWidth = this.pixelHeight * (val/100);
        let percentVal = (pWidth/this.pixelWidth) * 100;

        return this.roundHalf(percentVal);
    }

    roundHalf(number) {
        return Math.round(number*2) / 2;
    }

    setValidation() {
        if (!this.model) {
            return;
        }
        // Width in % of the layout width: x and width use the same units
        if (this.screenWidthUnits) {
            this.validation = {
                width: {min: 0, max: this.getSizeToEdge(this.model.x, 100) * 2},
                height: {min: 0, max: this.getSizeToEdge(this.model.y, 100) * 2},
                x: {min: this.roundHalf(this.model.width / 2), max: this.roundHalf(100 - this.model.width / 2)},
                y: {min: this.roundHalf(this.model.height / 2), max: this.roundHalf(100 - this.model.height / 2)}
            };
            return;
        }
        this.validation = {
            width: {
                min: 0,
                max: this.getSizeToEdge(this.roundHalf(this.model.x * (this.pixelWidth/this.pixelHeight)), this.roundHalf(this.pixelWidth/this.pixelHeight *100)) * 2
            },
            height: {
                min: 0,
                max: this.getSizeToEdge(this.model.y, 100) * 2
            } ,
            x: {
                min: this.roundHalf(this.getWidthInPercents(this.model.width)/2),
                max: this.roundHalf(100 - (this.getWidthInPercents(this.model.width)/2))
            },
            y: {
                min: this.roundHalf(this.model.height/2),
                max: this.roundHalf(100 - (this.model.height/2))
            }
        };
    }

    getSizeToEdge(pos, layout) {
        const half = layout/2;
        return pos > half ? layout - pos : pos;
    }

    onIconDownload() {
        setTimeout(() => {
            // Sync customIcon and custom_icon if both exist in model
            // Upload component sets customIcon, we need to sync it to custom_icon
            if (this.model && this.model.customIcon) {
                // Always sync custom_icon to match customIcon (upload component updates customIcon)
                this.model.custom_icon = this.model.customIcon;
            }

            // Trigger digest cycle to update any watchers (like preview)
            if (this.$scope && !this.$scope.$$phase && !this.$scope.$root.$$phase) {
                this.$scope.$apply();
            }

            const file = this.model && this.model.customIcon ? this.model.customIcon.attachment_file : null;
            if (!file) return;
            const lower = file.toLowerCase();
            // Skip dimension autosize for video files
            if (lower.indexOf(".mp4") !== -1 || lower.indexOf(".mov") !== -1 || lower.indexOf(".webm") !== -1) {
                return;
            }

            let image = new Image();
            image.src = file;
            image.onload = () => {
                const imgWidth = image.naturalWidth;
                const imgHeight = image.naturalHeight;
                if (imgHeight > imgWidth) {
                    this.model.width = this.roundHalf(imgWidth/imgHeight * this.model.height);
                } else {
                    this.model.height = this.roundHalf(imgHeight/imgWidth * this.model.width);
                }
                // Trigger digest cycle after image dimensions are updated
                if (this.$scope && !this.$scope.$$phase && !this.$scope.$root.$$phase) {
                    this.$scope.$apply();
                }
            };
        });
    }

    /**
     * Delete custom icon - clears both customIcon and custom_icon
     */
    deleteCustomIcon() {
        if (this.model) {
            if (this.deletePrevious) {
                const attachment = this.model.customIcon || this.model.custom_icon;
                const attachmentsUri = this.company ? `${this.company}attachments/` : null;
                this.$upload.deleteCompanyAttachment(attachmentsUri, attachment);
            }
            // Clear both customIcon and custom_icon to ensure proper cleanup
            this.model.customIcon = null;
            this.model.custom_icon = null;
            // Trigger digest cycle to update preview and UI
            if (this.$scope && !this.$scope.$$phase && !this.$scope.$root.$$phase) {
                this.$scope.$apply();
            }
        }
    }

}



// WEBPACK FOOTER //
// ./sources/components/common/start-screen-area/start-screen-area.controller.js